import { Component, Host, Prop, h, Element, State } from '@stencil/core';
import QRCode from 'qrcode';
import { mediaIconsDefault } from '../vs-social-share-container/sharelinks';
import { disableTabShift, trapFocus } from '@utils/trap-focus';
import { lockScroll } from '@utils/utils';

export type weChatButtonSize = 'small' | 'medium' | 'large';
export type weChatButtonColor = 'default' | 'primary' | 'black';

@Component({
  tag: 'vs-wechat-share',
  styleUrl: './_vs-wechat-share.scss',
  shadow: false,
})
export class WeChatShare {
  @Element() private element: HTMLElement;

  @Prop() dataTestId?: string = '';
  @Prop() buttonColor: weChatButtonColor = 'primary';
  @Prop() buttonSize: weChatButtonSize = 'small';
  @Prop() buttonAriaLabel: string = '';
  @Prop() modalHeader: string = '';
  @Prop() qrCodeAltText: string = '';
  @Prop() closeModalAriaLabel: string = '';

  @State() weChatModalVisible: boolean = false;
  weChatModal: HTMLElement;

  componentWillLoad() {
    this.escapeWeChatModal();
  }

  componentDidLoad() {
    this.weChatModal = this.element.querySelector<HTMLElement>('.vs-wechat-modal-wrapper');
    const opts = {
      errorCorrectionLevel: 'H',
      type: 'image/jpeg',
      margin: 0,
      width: 125,
    };
    QRCode.toCanvas(document.getElementById('vs-wechat-canvas'), window.location.href, opts, function (error) {
      if (error) console.error(error);
    });
  }

  showWeChatModal = () => {
    this.element.querySelector<HTMLElement>('#vs-wechat-modal').classList.remove('vs-hide-wechat-modal', 'vs-d-none');
    this.weChatModal.focus();
    if (document.getElementById('vs-share-modal')) {
      disableTabShift(document.getElementById('vs-share-modal'));
    }

    trapFocus(this.weChatModal);
    this.weChatModalVisible = true;
    lockScroll(true);
  };

  hideWeChatModal = () => {
    this.element.querySelector<HTMLElement>('#vs-wechat-modal').classList.add('vs-hide-wechat-modal', 'vs-d-none');
    this.weChatModalVisible = false;
    if (document.getElementById('vs-share-modal')) {
      trapFocus(document.getElementById('vs-share-modal'));
    }
    this.element.querySelector<HTMLElement>('.vs-wechat-btn').focus();
    const shareModal = document.querySelector<HTMLElement>('.vs-social-share-modal-wrapper');
    if (shareModal && shareModal.getAttribute('data-share-modal') === 'visible') {
      lockScroll(true);
    } else {
      lockScroll(false);
    }
  };

  escapeWeChatModal = () => {
    window.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.weChatModalVisible) {
        this.hideWeChatModal();
      }
    });
  };

  render() {
    return (
      <Host>
        <button
          class={'vs-wechat-btn visa-icon ' + mediaIconsDefault['wechat']}
          aria-label={this.buttonAriaLabel}
          onClick={this.showWeChatModal}
          data-button-size={this.buttonSize}
          data-button-color={this.buttonColor}
          {...(this.dataTestId.length && { 'data-test-id': 'wechat-button-' + this.dataTestId })}
        ></button>

        <div
          class="vs-wechat-modal-wrapper vs-hide-wechat-modal vs-d-none"
          id="vs-wechat-modal"
          tabindex="-1"
          role="dialog"
          aria-modal="true"
          aria-describedby="vs-wechat-header"
          data-modal={this.weChatModalVisible ? 'visible' : 'hidden'}
          {...(this.dataTestId.length && { 'data-test-id': 'wechat-modal-' + this.dataTestId })}
        >
          <div class="vs-wechat-share-modal">
            <h2 class="vs-text vs-wechat-header-text" id="vs-wechat-header">
              {this.modalHeader}
            </h2>
            <div class="vs-align-center vs-d-flex vs-justify-content-end vs-wechat-close">
              <button class="visa-icon visa-icon-close" id="share-modal-close-id" onClick={this.hideWeChatModal} aria-label={this.closeModalAriaLabel}></button>
            </div>
            <canvas id="vs-wechat-canvas" class="vs-wechat-qr" role="img" aria-label={this.qrCodeAltText}></canvas>
          </div>
        </div>
      </Host>
    );
  }
}
